export default "__VITE_ASSET__DDktg34L__"